const result = {
    title: 'Medical Document - Result',
    productReg: 'Product Reg. No',
    outputType: 'Output Type',
    selectOutputType: 'Select Output Type',
    outputFileName: 'Output File Name',
    selectOutputFileName: 'Select Output File Name',
    selectExaminationItem: 'Select Examination Item',
    mrNo: 'MR No',
    patientName: 'Patient Name',
    patientCategory: 'Patient Category',
    viewSelectedExaminationItem: 'View Selected Examination Item',
    status: 'Status',
    button: {
        bulkPrint: {
            name: 'Bulk Print',
            chile: {
                label: 'Label',
                result: 'Result',
                resultItem: 'Result Item'
            }
        },
        bulkSend: {
            name: 'Bulk Send',
            chile: {
                result: 'Result',
                resultItem: 'Result Item'
            }
        },
        export: 'Export',
        formatPrint: 'Format Print',
        updateFormat: 'Update Format',
        updateFormatList: 'Update Format List'

    },

    modal: {
        sendModal: {
            titleWhatAppResultItem: 'Send WhatsApp Examination Result Item',
            titleWhatAppResult: 'Send WhatsApp Examination Result',
            titleEmailResultItem: 'Send Email Examination Result Item',
            titleEmailResult: 'Send Email Examination Result',
            mobilePhone: 'Mobile Phone',
            requiredMobilePhone: 'Please ensure the number is actively using WhatsApp',
            email: 'Email',
            requiredEmail: 'Please ensure the email is active'
        },
        modalExport: {
            title: 'Export Medical Document',
            message: 'Are you sure want to export medical document list patient?'
        },
        advanceSearch: {
            title: 'Advance Search Data Examination Result'
        },
        medicalDocument: {
            title: 'Medical Document Format'
        },
        printExaminationResult: {
            title: 'Print Examination Result',
            titleBulk: 'Bulk Print Examination Result',
            patientName: 'Patient Name',
            registrationNumber: 'Registration Number',
            sendBy: 'Send By',
            patientCategory: 'Patient Category',
            printType: 'Print Type',
            selectPrintType: 'Select Print Type',
            language: 'Language',
            multilingualLayout: 'Multilingual Layout',
            selectMultilingualLayout: 'Select Multilingual Layout'
        },
        printExaminationResultItem: {
            title: 'Print Examination Result Item',
            titleBulk: 'Bulk Print Examination Result Item'
        },
        bulkSendExamination: {
            sendBy: 'Send By',
            selectSendBy: 'Select Send By',
            titleResult: 'Bulk Send Examination Result',
            titleResultItem: 'Bulk Send Examination Result Item'
        },
        confirm: {
            label: {
                title: 'Print MCU Label',
                titleBulk: 'Bulk Print MCU Label',
                message: 'Are you sure want to Print MCU Label for selected patient?'
            }
        }
    }
}

export default result